var map = {
	"./Fax_contact.png": "7f92",
	"./facebook_contact.png": "b3ba",
	"./instagram_contact.png": "be41",
	"./mail_contact.png": "55b1",
	"./ngo_Fax_contact.png": "22bc",
	"./ngo_facebook_contact.png": "1759",
	"./ngo_instagram_contact.png": "4cbf",
	"./ngo_mail_contact.png": "d3c5",
	"./ngo_phone_contact.png": "d2f8",
	"./ngo_skype_contact.png": "324a",
	"./ngo_whatsapp_contact.png": "4f91",
	"./phone_contact.png": "2294",
	"./skype_contact.png": "7862",
	"./whatsapp_contact.png": "49f51"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c806";